import { Dependente } from './../shared/model/Dependente.model';
import { Component, OnInit } from '@angular/core';
import { DependenteService } from './dependente.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';



@Component({templateUrl: './dependente.component.html', styleUrls: ['./dependente.component.css']})
export class DependenteComponent implements OnInit {

  listaDependentes: Dependente[];
  dependente: Dependente;
  valueFilter = '';
  idDependente: number;

  matricula = '';
  beneficiado = '';
  nomeColaborador: string;
  cpfColaborador: string;

  listaBeneficiarios = [];
  listaBeneficiariosCombo = [];
  disabledBeneficiarios = true;

  constructor(private dependeteService: DependenteService, private toast: ToastrService,
     config: NgbModalConfig, private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
    }

  ngOnInit() {
    this.getDependentes();
  }

  private getDependentes() {
    this.dependeteService.listarDependentes(this.valueFilter).subscribe(
      (dados: Dependente[]) => {
        this.listaDependentes = dados;
      }
    );
  }

  novoDependenteModal(content) {
    this.dependente = new Dependente();

    this.modalService.open(content, { size: 'lg' });
  }

  salvarDependente(form) {
    this.listaBeneficiarios.forEach(dependente => {
      if (dependente.Nome === this.beneficiado) {

        this.dependente.idApi = dependente.IdDependente;
        this.dependente.nomeDependente = dependente.Nome;
        this.dependente.cpfResponsavel = +this.cpfColaborador;

        this.dependeteService.salvarDependente(this.dependente).subscribe(() => {
          this.getDependentes();
          this.toast.success('Dependente salvo com sucesso!');
          this.modalService.dismissAll();
          form.reset();
          this.limparVariaves();
        },
        erro => {
          this.toast.error('Erro ao cadastrar o dependente, tente novamente!');
          }
        );
      }
    });
  }

  deletarModal(content, idDependente: number) {
    this.idDependente = idDependente;

    this.modalService.open(content);
  }

  deletarDependente(form) {
    this.dependeteService.deletarDependente(this.idDependente).subscribe(
      () => {
        this.toast.success('Dependente apagado com sucesso!');
        this.getDependentes();
        form.reset();
      },
      () => this.toast.error('Erro ao apagar o dependente, tente novamente!')
    );
    this.modalService.dismissAll();
  }

  buscarDependente() {
    this.getDependentes();
  }

  buscarDependenteEspecialPorMatricula(matricula: string) {
    if (matricula.length === 7) {
      this.dependeteService.buscarColaboradorPorMatricula(matricula).subscribe(
        (dados) => {
          this.limparVariaves();

          if (dados !== null) {
            this.nomeColaborador = dados.Nome;
            this.cpfColaborador = dados.CPF;
            this.listaBeneficiarios = dados.Dependentes;
            this.buildComboBeneficiarios(dados.Dependentes);
            this.disabledBeneficiarios = false;
          }
        }
      );
    }
  }

  buildComboBeneficiarios(dependentes) {
    dependentes.forEach(dependente => {
      this.listaBeneficiariosCombo.push(dependente.Nome);
    });
  }

  limparVariaves() {
      this.matricula = '';
      this.listaBeneficiariosCombo = [];
      this.nomeColaborador = '';
      this.cpfColaborador = '';
      this.disabledBeneficiarios = true;
  }
}
